<template>
    <div id="camera-dialog">
        <el-dialog
                title="拍摄照片"
                :visible.sync="dialogVisible"
                top="5vh"
                width="481px"
                @close="dialogCancle"
                :close-on-click-modal="true"
                :before-close="dialogCancle"
        >
            <Camera :show="dialogVisible" @fileUploadSuccess="fileUploadSuccess" @cameraAskFailure="dialogCancle"></Camera>
            <span slot="footer" class="dialog-footer">
        </span>
        </el-dialog>
    </div>
</template>

<script>
    import Camera from "@/components/camera"

    export default {
        name: 'CameraDialog',
        props: {
            dialogVisible: {type: Boolean},
            deleteData: {type: Object}
        },
        watch:{
            dialogVisible:{
                immediate: true,
                handler (val) {
                    this.dialogVisibleCopy = val
                },
                deep: true
            },
        },

        components: {
            Camera
        },
        data() {
            return {
                fileId: ``,
                filePath: ``,
                dialogVisibleCopy:'',
            }
        },
        methods: {
            //关闭弹窗
            dialogCancle() {
                this.$emit('dialogCancle', this.fileId, this.filePath);
            },
            //获取人脸照片地址
            fileUploadSuccess(filePath) {
                this.filePath =  filePath || ''
                this.dialogCancle()
            }
        }
    }
</script>

<style scoped>
</style>
